import { tryAgainLaterText } from './addSharedFolderUser.locstring.json';
import { addSharedFolderUserEmail } from '../actions/addSharedFolderUserEmail';
import { onAddSharedFolderSuccess } from '../actions/onAddSharedFolderSuccess';
import addSharedFoldersService from '../services/addSharedFoldersService';
import { logUsage } from 'owa-analytics';
import { confirm } from 'owa-confirm-dialog';
import { Folder } from 'owa-folders';
import { SHARED_FOLDERS_TREE_TYPE } from 'owa-folders-constants';
import loc from 'owa-localize';
import { cantCompleteRequestText } from 'owa-locstrings/lib/strings/cantcompleterequesttext.locstring.json';
import { trace } from 'owa-trace';
import { getDefaultLogonEmailAddress } from 'owa-session-store';

export async function addSharedFolderUser(
    displayName: string,
    sharedUserMailboxSmtpAddress: string,
    skipServerValidation: boolean = false,
    userIdentity: string = getDefaultLogonEmailAddress()
) {
    try {
        // While initializing the shared folder root, we add it directly in folder pane if we get the user info in the getOtherMailboxConfiguration response
        // User can explicitly remove the shared folder user, if he gets an error while expanding the tree
        if (!skipServerValidation) {
            const response = await addSharedFoldersService(
                displayName,
                sharedUserMailboxSmtpAddress
            );
            if (!response) {
                return;
            }
        }
    } catch (error) {
        confirm(loc(cantCompleteRequestText), loc(tryAgainLaterText), false, {
            hideCancelButton: true,
        });
        trace.error('Add shared folder API returned error ' + error);
        return;
    }
    const folder: Folder = {
        FolderId: {
            Id: sharedUserMailboxSmtpAddress,
        },
        isHidden: false,
        DisplayName: displayName,
        treeType: SHARED_FOLDERS_TREE_TYPE,
        principalSMTPAddress: sharedUserMailboxSmtpAddress,
    };

    onAddSharedFolderSuccess(sharedUserMailboxSmtpAddress, folder, userIdentity);
    addSharedFolderUserEmail(sharedUserMailboxSmtpAddress, userIdentity);

    // Will only log add shared folder request initiated by the user.
    if (!skipServerValidation) {
        logUsage('Triage_SharedFolders_AddFolder');
    }
}
